var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"position":"fixed","left":"0","top":"0"},attrs:{"id":"pageLoaded"}},[_vm._v(" ")])}
var staticRenderFns = []

export { render, staticRenderFns }